import { numericOnly } from '@/directives/numericOnly'
import DocumentsApi from '../api'
import numberFormat from '@/filters/numberFormat'

export default {
  data () {
    return {
      saving: false
    }
  },
  directives: {
    numericOnly
  },
  filters: {
    numberFormat
  },
  computed: {
    commonQty () {
      let commonQty = 0
      this.document.records.forEach((record, i, arr) => {
        commonQty += record.kolichestvo
      })
      return commonQty
    }
  },
  methods: {
    async deleteDocument () {
      let response = await DocumentsApi.deleteDocument({ name: this.name, docId: this.id })
      if (response.success) {
        this.$router.go(-1)
      } else {
        console.log(response.error)
      }
    },
    async saveDocument () {
      this.saving = true
      let response = await DocumentsApi.saveDocument({
        id: this.id,
        name: this.name,
        records: this.getRecordsForSave(),
        comment: this.document.comment
      })
      if (response.success) {
        response.document.summa = parseFloat(response.document.summa)
        this.document = response.document
        this.messageType = 'success'
        this.messageText = 'Документ сохранен'
        this.messageDisplay = true
      } else {
        console.log(response.error)
      }
      this.saving = false
    }
  }
}
